import firebase from 'firebase/compat/app';
//import firebase from 'firebase';
//import { initializeApp } from "firebase/app";

const firebaseConfig = {
                        apiKey: "AIzaSyCQd7CV4VrzLQRh-d4sP9ULpy6EFxxbOlM",
                        authDomain: "apprestaurante-bb791.firebaseapp.com",
                        projectId: "apprestaurante-bb791",
                        storageBucket: "apprestaurante-bb791.appspot.com",
                        messagingSenderId: "244061105597",
                        appId: "1:244061105597:web:c5d786d5e2ce421b62b6d4"
  };
  
  // Initialize Firebase
export default firebase.initializeApp(firebaseConfig);
